var _g, _rect, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlockedRoom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 84,
    viewBox: "0 0 84 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_3677_22413)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 10,
    width: 64,
    height: 64,
    rx: 10,
    fill: "white"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 16,
    width: 52,
    height: 52,
    rx: 6,
    fill: "#ADAEB9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M31.2187 28.5253C30.8658 28.1844 30.3932 27.9958 29.9026 28.0001C29.412 28.0043 28.9428 28.2011 28.5959 28.548C28.249 28.895 28.0522 29.3643 28.0479 29.8549C28.0437 30.3455 28.2323 30.8182 28.5731 31.1711L39.3783 41.977L28.5712 52.7829C28.3925 52.9555 28.25 53.162 28.1519 53.3903C28.0538 53.6186 28.0022 53.8641 28.0001 54.1126C27.9979 54.361 28.0453 54.6074 28.1393 54.8374C28.2334 55.0673 28.3723 55.2763 28.548 55.452C28.7237 55.6276 28.9326 55.7666 29.1625 55.8607C29.3925 55.9547 29.6389 56.0021 29.8873 55.9999C30.1357 55.9978 30.3812 55.9462 30.6095 55.8481C30.8378 55.75 31.0442 55.6075 31.2168 55.4288L42.0239 44.6228L52.8291 55.4288C53.182 55.7696 53.6546 55.9582 54.1452 55.9539C54.6358 55.9497 55.1051 55.7529 55.452 55.406C55.7989 55.059 55.9957 54.5897 55.9999 54.0991C56.0042 53.6085 55.8156 53.1358 55.4748 52.7829L44.6696 41.977L55.4748 31.1711C55.8156 30.8182 56.0042 30.3455 55.9999 29.8549C55.9957 29.3643 55.7989 28.895 55.452 28.548C55.1051 28.2011 54.6358 28.0043 54.1452 28.0001C53.6546 27.9958 53.182 28.1844 52.8291 28.5253L42.0239 39.3312L31.2187 28.5234V28.5253Z",
    fill: "#666666"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_3677_22413",
    x: 0,
    y: 0,
    width: 84,
    height: 84,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3677_22413"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3677_22413",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlockedRoom);
export default __webpack_public_path__ + "static/media/blocked-room.a6e04a0b6f65dd7a505645e341a3ec2c.svg";
export { ForwardRef as ReactComponent };